import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface RequestItemEntityParams {
  distributor_id: number;
  product_id: number;
}

export class RequestItemEntity extends BaseEntityClass {
  distributor_id: number;
  product_id: number;

  constructor(params: RequestItemEntityParams) {
    super();
    this.type = "request_item";
    this.entity_version = 1;
    this.distributor_id = params.distributor_id;
    this.product_id = params.product_id;
  }
}
